var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('img',{staticClass:"user_image",attrs:{"src":require("../assets/user.png"),"mode":"widthFix"}}),_c('div',{staticClass:"user_foot"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.nodes)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }